// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/lib/components/content-documents/media-document/tags/tags.scss
// module id = 168
// module chunks = 0